import _ from "lodash"
import React from "react"
import { useParams } from "react-router-dom"

type RequiredRouteParamsProps = {
    paramId: string
    children: (param: string) => React.ReactElement
}

export const RequiredRouterParam = ({ paramId, children }: RequiredRouteParamsProps) => {
    const params = useParams()

    return params[paramId] ? children(params[paramId] as string) : null
}

type OptionalRouteParamsProps = {
    paramId: string
    children: (param?: string) => React.ReactElement
}

export const OptionalRouterParam = ({ paramId, children }: OptionalRouteParamsProps) => {
    const params = useParams()
    return children(params[paramId])
}
